import { render, staticRenderFns } from "./Reserves.vue?vue&type=template&id=695edad8&"
import script from "./Reserves.vue?vue&type=script&lang=ts&"
export * from "./Reserves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports